<template>
  <ul class="navigation clearfix">
    <li v-for="item in menuItems"
        :key="item.title"
        @click="closeNav"
        class="navigation__item">
      <router-link :to="item.link"
                   router
                   :title="item.title">
        {{ item.title }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'navigation',
  data () {
    return {
      menuItems: [
        { title: 'home', link: '/' },
        { title: 'Floral Design', link: '/floral-design' },
        { title: 'Decor Hire', link: '/decor-hire' },
        { title: 'Our Work', link: '/our-work' },
        { title: 'Get In Touch', link: '/get-in-touch' },
      ],
    }
  },
  methods: {
    closeNav () {
      this.$emit('closeNav')
    },
  },
}
</script>
